import { MenuItem, UserRole } from '../types';

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'Dashboard',
    path: '/dashboard',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER, UserRole.MOD, UserRole.CALL_ADMIN, UserRole.CALL, UserRole.LIVECHAT_ADMIN, UserRole.LIVECHAT, UserRole.RISK_ADMIN, UserRole.RISK]
  },
  {
    id: 'reports',
    title: 'Raporlar',
    icon: 'Assessment',
    path: '/reports/create',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER, UserRole.MOD, UserRole.CALL_ADMIN, UserRole.CALL, UserRole.LIVECHAT_ADMIN, UserRole.LIVECHAT, UserRole.RISK_ADMIN, UserRole.RISK]
  },
  {
    id: 'work-time',
    title: 'Mesai Takibi',
    icon: 'AccessTime',
    path: '/work-time',
    roles: [UserRole.ADMIN, UserRole.CALL_ADMIN, UserRole.LIVECHAT_ADMIN, UserRole.RISK_ADMIN, UserRole.CALL, UserRole.LIVECHAT, UserRole.RISK]
  },
  {
    id: 'chat',
    title: 'Canlı Chat',
    icon: 'Chat',
    path: '/chat',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER, UserRole.MOD, UserRole.CALL_ADMIN, UserRole.CALL, UserRole.LIVECHAT_ADMIN, UserRole.LIVECHAT, UserRole.RISK_ADMIN, UserRole.RISK]
  },
  {
    id: 'users',
    title: 'Kullanıcı Yönetimi',
    icon: 'People',
    path: '/users',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER]
  },
  {
    id: 'page-settings',
    title: 'Sayfa Ayarları',
    icon: 'Web',
    path: '/settings/pages',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER]
  },
  {
    id: 'css-settings',
    title: 'CSS Düzenleme',
    icon: 'Code',
    path: '/settings/css',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER]
  },
  {
    id: 'sidebar-settings',
    title: 'Sidebar Ayarları',
    icon: 'Menu',
    path: '/settings/sidebar',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER]
  },
  {
    id: 'report-settings',
    title: 'Rapor Ayarları',
    icon: 'Settings',
    path: '/settings/reports',
    roles: [UserRole.ADMIN]
  },
  {
    id: 'logs',
    title: 'Loglar',
    icon: 'History',
    path: '/logs',
    roles: [UserRole.ADMIN]
  },
  {
    id: 'panel',
    title: 'Panel',
    icon: 'Web',
    path: '/panel',
    roles: [UserRole.ADMIN, UserRole.DEVELOPER, UserRole.MOD, UserRole.CALL_ADMIN, UserRole.CALL, UserRole.LIVECHAT_ADMIN, UserRole.LIVECHAT, UserRole.RISK_ADMIN, UserRole.RISK]
  }
];

// Kullanıcının rolüne göre menü öğelerini filtrele
export const getFilteredMenuItems = (userRole: UserRole): MenuItem[] => {
  return menuItems.filter(item => item.roles.includes(userRole));
};
